import React from "react";
const defaultConfig = {
    getId: (item) => item.id || item.toString(),
};
export default function useEditList(list, config) {
    const safeConfig = React.useMemo(() => (Object.assign(Object.assign({}, defaultConfig), config)), [config]);
    const [changes, setChanges] = React.useState({});
    const update = React.useMemo(() => (addition) => {
        if (Array.isArray(addition)) {
            const additionObject = addition.reduce((sum, add) => (Object.assign(Object.assign({}, sum), { [safeConfig.getId(add)]: add })), {});
            setChanges((c) => (Object.assign(Object.assign({}, c), additionObject)));
        }
        else {
            setChanges((c) => (Object.assign(Object.assign({}, c), { [safeConfig.getId(addition)]: addition })));
        }
    }, [safeConfig]);
    const deleteItem = React.useMemo(() => (deleteId) => {
        // @ts-expect-error - TS2345 - Argument of type '(c: { [key: string]: T; }) => { [x: string]: T | null; }' is not assignable to parameter of type 'SetStateAction<{ [key: string]: T; }>'.
        setChanges((c) => (Object.assign(Object.assign({}, c), { [deleteId]: null })));
    }, []);
    const reset = React.useRef(() => setChanges({}));
    const newData = React.useMemo(() => Object.values(Object.assign(Object.assign({}, list.reduce((sum, datum) => (Object.assign(Object.assign({}, sum), { [safeConfig.getId(datum)]: datum })), {})), changes)).filter((datum) => datum !== null), [changes, list, safeConfig]);
    const actions = React.useMemo(() => ({ update, deleteItem, reset: reset.current }), [deleteItem, update]);
    return [newData, actions];
}
